import http_request from './http_request'
import config from 'config'

function getLessonMetadata(presentationUid, headers) {
	return http_request.get(`${config.api}presentation/${presentationUid}/metadata`)
		.withHeaders(headers)
		.send()
}

export default {
	getLessonMetadata,
}
